// -----------------------------------------------------------------------------
// Hilfreiche Funktionen für Arrays
// -----------------------------------------------------------------------------

/**
 * Prüft, ob zumindest ein Element des Needle-Arrays im Haystack-Array vorhanden ist
 *
 * @param aNeedle
 * @param aHaystack
 * @returns {boolean}
 */
const containsArrayPartially = (aNeedle = [], aHaystack = []) => {
  // `false`, wenn Haystack kein Array ist
  if (Array.isArray(aHaystack) === false) {
    return false;
  }

  // `true`, wenn Needle kein Array ist
  if (Array.isArray(aNeedle) === false) {
    return true;
  }

  // `true`, wenn zumindest ein Element der Needle im Haystack vorhanden ist
  return aNeedle.some((element) => {
    return aHaystack.includes(element);
  });
};

/**
 * Liefert zusammengefügtes assoziatives Array zurück
 *
 * @param arr
 * @param separator
 * @returns {string}
 */
const joinAssoc = (arr = [], separator = ',') => {
  let aOutput = [];
  for (let i in arr) {
    if (arr.hasOwnProperty(i) === false) {
      continue;
    }

    aOutput.push(arr[i]);
  }
  return aOutput.join(separator);
};

/**
 * Liefert Array aus Schlüsseln eines assoziativen Arrays zurück
 *
 * @param arr
 * @returns {Array}
 */
const getKeysAssoc = (arr = []) => {
  let aOutput = [];
  for (let key in arr) {
    if (arr.hasOwnProperty(key) === false) {
      continue;
    }

    aOutput.push(key);
  }
  return aOutput;
};

/**
 * Element aus Array entfernen
 *
 * @param element
 * @param arr
 * @returns {Array}
 */
const removeElement = (element, arr = []) => {
  const index = arr.indexOf(element);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
};

/**
 * Entfernt Leerstrings aus Array
 *
 * @param arr
 * @returns {Array.<*>}
 */
const removeEmpty = (arr = []) => {
  return arr.filter(item => item);
};

export {
  containsArrayPartially,
  getKeysAssoc,
  joinAssoc,
  removeElement,
  removeEmpty
};
